var cov_1jufrpv3gs = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Lazyload/index.tsx",
      hash = "87b7a926ef091ef1e5d19f1cd995a0cb16afccf5",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Lazyload/index.tsx",
    statementMap: {
      "0": {
        start: {
          line: 11,
          column: 21
        },
        end: {
          line: 13,
          column: 1
        }
      },
      "1": {
        start: {
          line: 23,
          column: 4
        },
        end: {
          line: 23,
          column: 16
        }
      },
      "2": {
        start: {
          line: 24,
          column: 4
        },
        end: {
          line: 24,
          column: 33
        }
      },
      "3": {
        start: {
          line: 28,
          column: 56
        },
        end: {
          line: 28,
          column: 66
        }
      },
      "4": {
        start: {
          line: 29,
          column: 4
        },
        end: {
          line: 34,
          column: 6
        }
      },
      "5": {
        start: {
          line: 33,
          column: 20
        },
        end: {
          line: 33,
          column: 50
        }
      },
      "6": {
        start: {
          line: 38,
          column: 4
        },
        end: {
          line: 38,
          column: 28
        }
      },
      "7": {
        start: {
          line: 42,
          column: 4
        },
        end: {
          line: 42,
          column: 25
        }
      },
      "8": {
        start: {
          line: 46,
          column: 22
        },
        end: {
          line: 46,
          column: 32
        }
      },
      "9": {
        start: {
          line: 47,
          column: 38
        },
        end: {
          line: 47,
          column: 48
        }
      },
      "10": {
        start: {
          line: 49,
          column: 4
        },
        end: {
          line: 49,
          column: 30
        }
      },
      "11": {
        start: {
          line: 49,
          column: 15
        },
        end: {
          line: 49,
          column: 30
        }
      },
      "12": {
        start: {
          line: 50,
          column: 4
        },
        end: {
          line: 54,
          column: 5
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 22,
            column: 2
          },
          end: {
            line: 22,
            column: 3
          }
        },
        loc: {
          start: {
            line: 22,
            column: 36
          },
          end: {
            line: 25,
            column: 3
          }
        },
        line: 22
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 27,
            column: 2
          },
          end: {
            line: 27,
            column: 3
          }
        },
        loc: {
          start: {
            line: 27,
            column: 22
          },
          end: {
            line: 35,
            column: 3
          }
        },
        line: 27
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 33,
            column: 14
          },
          end: {
            line: 33,
            column: 15
          }
        },
        loc: {
          start: {
            line: 33,
            column: 20
          },
          end: {
            line: 33,
            column: 50
          }
        },
        line: 33
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 37,
            column: 2
          },
          end: {
            line: 37,
            column: 3
          }
        },
        loc: {
          start: {
            line: 37,
            column: 25
          },
          end: {
            line: 39,
            column: 3
          }
        },
        line: 37
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 41,
            column: 19
          },
          end: {
            line: 41,
            column: 20
          }
        },
        loc: {
          start: {
            line: 41,
            column: 44
          },
          end: {
            line: 43,
            column: 3
          }
        },
        line: 41
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 45,
            column: 2
          },
          end: {
            line: 45,
            column: 3
          }
        },
        loc: {
          start: {
            line: 45,
            column: 11
          },
          end: {
            line: 55,
            column: 3
          }
        },
        line: 45
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 28,
            column: 23
          },
          end: {
            line: 28,
            column: 51
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 28,
            column: 32
          },
          end: {
            line: 28,
            column: 51
          }
        }],
        line: 28
      },
      "1": {
        loc: {
          start: {
            line: 49,
            column: 4
          },
          end: {
            line: 49,
            column: 30
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 49,
            column: 4
          },
          end: {
            line: 49,
            column: 30
          }
        }, {
          start: {
            line: 49,
            column: 4
          },
          end: {
            line: 49,
            column: 30
          }
        }],
        line: 49
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0
    },
    b: {
      "0": [0],
      "1": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/spana/SHEIN/shineout/src/Lazyload/index.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import { PureComponent } from '../component';
import { lazyloadClass } from './styles';
import { addStack, removeStack } from '../utils/lazyload';
var DefaultProps = (cov_1jufrpv3gs.s[0]++, {
  offset: 0
});

var Lazyload =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Lazyload, _PureComponent);

  var _super = _createSuper2(Lazyload);

  function Lazyload(props) {
    var _this;

    _classCallCheck(this, Lazyload);

    cov_1jufrpv3gs.f[0]++;
    cov_1jufrpv3gs.s[1]++;
    _this = _super.call(this, props);
    _this.placeholder = void 0;
    _this.lazyId = void 0;

    _this.placeholderRef = function (el) {
      cov_1jufrpv3gs.f[4]++;
      cov_1jufrpv3gs.s[7]++;
      _this.placeholder = el;
    };

    cov_1jufrpv3gs.s[2]++;
    _this.state = {
      ready: false
    };
    return _this;
  }

  _createClass(Lazyload, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      cov_1jufrpv3gs.f[1]++;

      var _ref = (cov_1jufrpv3gs.s[3]++, this.props),
          container = _ref.container,
          _ref$offset = _ref.offset,
          offset = _ref$offset === void 0 ? (cov_1jufrpv3gs.b[0][0]++, DefaultProps.offset) : _ref$offset;

      cov_1jufrpv3gs.s[4]++;
      this.lazyId = addStack({
        offset: offset,
        container: container,
        element: this.placeholder,
        render: function render() {
          cov_1jufrpv3gs.f[2]++;
          cov_1jufrpv3gs.s[5]++;
          return _this2.setState({
            ready: true
          });
        }
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      cov_1jufrpv3gs.f[3]++;
      cov_1jufrpv3gs.s[6]++;
      removeStack(this.lazyId);
    }
  }, {
    key: "render",
    value: function render() {
      cov_1jufrpv3gs.f[5]++;

      var _ref2 = (cov_1jufrpv3gs.s[8]++, this.state),
          ready = _ref2.ready;

      var _ref3 = (cov_1jufrpv3gs.s[9]++, this.props),
          children = _ref3.children,
          placeholder = _ref3.placeholder;

      cov_1jufrpv3gs.s[10]++;

      if (ready) {
        cov_1jufrpv3gs.b[1][0]++;
        cov_1jufrpv3gs.s[11]++;
        return children;
      } else {
        cov_1jufrpv3gs.b[1][1]++;
      }

      cov_1jufrpv3gs.s[12]++;
      return (
        /*#__PURE__*/
        React.createElement("span", {
          ref: this.placeholderRef,
          className: lazyloadClass('_'),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 51,
            columnNumber: 7
          }
        }, placeholder)
      );
    }
  }]);

  return Lazyload;
}(PureComponent);

Lazyload.defaultProps = DefaultProps;
export default Lazyload;